import type { components } from '@/api/schema';

/** T232: Hisob MMT → merchant payout for an approved invoice (murabaha step 7). */
export const PAYOUT_STATUSES = ['pending', 'paid', 'failed'] as const;
export type PayoutStatus = (typeof PAYOUT_STATUSES)[number];
export type MerchantPayout = components['schemas']['MerchantPayoutResource'];

export const payoutColors: Record<PayoutStatus, string> = {
  pending: 'bg-warning/15 text-warning',
  paid: 'bg-success/15 text-success',
  failed: 'bg-destructive/15 text-destructive',
};
